import React from "react";
import PropTypes from "prop-types";
import analytics from "web/script/analytics/analytics";
import ProductGalleryCarousel from "web/react/components/product-gallery/product-gallery-carousel/product-gallery-carousel";
import ProductGalleryModal from "web/react/components/product-gallery/product-gallery-modal/product-gallery-modal";
import { ProductImagePropType } from "web/types/product.js";
import { ProductCardPropType } from "web/types/product-card.js";


function FullscreenGallery({
    analyticsAction,
    isOpen,
    onClose,
    currentSlideIndex,
    images,
    relatedProducts,
}) {
    let fullscreenSettings = {
        speed: 200,
        cssEase: "ease-out",
        slidesToShow: 1,
        infinite: true,
        arrows: false,
        dots: true,
        lazyLoad: false,
        centerMode: false,
        touchThreshold: 20,
        swipeToSlide: true,
        initialSlide: currentSlideIndex,
    };

    let fullscreenProps = {
        analyticsAction: analyticsAction,
        images: images,
        isFullscreen: true,
        relatedProducts: relatedProducts,
        settings: fullscreenSettings,
        showRelatedProducts: true,
    };

    function onOpen() {
        analytics.event("engagement", analyticsAction, "open_fullscreen");
    }

    return (
        <ProductGalleryModal isOpen={isOpen} onClose={onClose} onOpen={onOpen}>
            <ProductGalleryCarousel {...fullscreenProps} />
        </ProductGalleryModal>
    );
}

FullscreenGallery.propTypes = {
    analyticsAction: PropTypes.string.isRequired,
    currentSlideIndex: PropTypes.number,
    onClose: PropTypes.func.isRequired,
    images: PropTypes.arrayOf(ProductImagePropType).isRequired,
    isOpen: PropTypes.bool,
    relatedProducts: PropTypes.arrayOf(ProductCardPropType),
};

FullscreenGallery.defaultProps = {
    currentSlideIndex: 0,
    isOpen: false,
};

export default FullscreenGallery;
